import React from 'react';
import icon from '../../Media/icon-line-w.png'
import appleIcon from '../../Media/apple-icon.png'
import playIcon from '../../Media/play-icon.png'

const Sec1 = () => {
    return (
        <div className='bg-img-2 bg-cover text-white md:py-40 py-28 md:px-20 px-5'>
            <h1 className='md:text-9xl text-4xl font-bold shadow-xs'>Life on LINE</h1>
            <h4 className='md:text-4xl text-2xl font-bold my-5'>LINE—always at your side.</h4>
            <div className='flex items-center cursor-pointer'>
                <img src={icon} alt="" />
                <p className='text-lg font-bold ml-1'>Download</p>
            </div>
            <div className='my-3'>
                <button className='p-3 border rounded-md hover:bg-lime-500'>
                    <img src={appleIcon} alt="" />
                </button>
                <button className='p-3 border rounded-md hover:bg-lime-500 mx-1'>
                    <img src={playIcon} alt="" />
                </button>
                <button className='p-3 border rounded-md hover:bg-lime-500'>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-[30px] h-[30px]">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M9 17.25v1.007a3 3 0 01-.879 2.122L7.5 21h9l-.621-.621A3 3 0 0115 18.257V17.25m6-12V15a2.25 2.25 0 01-2.25 2.25H5.25A2.25 2.25 0 013 15V5.25m18 0A2.25 2.25 0 0018.75 3H5.25A2.25 2.25 0 003 5.25m18 0V12a2.25 2.25 0 01-2.25 2.25H5.25A2.25 2.25 0 013 12V5.25" />
                    </svg>
                </button>
            </div>
        </div>
    );
};

export default Sec1;